import { Outlet } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";

/**
 * Layout principal que envuelve toda la aplicación.
 * Proporciona el sistema de temas y las notificaciones globales.
 */
export function Layout() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="psdn-ui-theme">
      <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
        <main>
          <Outlet />
        </main>
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}
